import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import DraftjsTextField from './DraftjsTextField';


const HELPER_TEXT = {
  anchor: 'Hint: Type \'@\' to tag your friends',
  fan: 'Hint: Type \'@\' to mention someone',
};


const RichTextField = forwardRef((props, ref) => {
  const { anchorSubscriptions, isFan } = props;

  const mentionsList = [];
  anchorSubscriptions.forEach((anchor) => {
    mentionsList.push({
      name: anchor?.anchorName,
      id: parseInt(anchor?.subCategory, 10),
      nickname: anchor?.anchorNickname,
    });
  });

  return (
    <DraftjsTextField
      ref={ref}
      mentionHelperText={isFan ? HELPER_TEXT.fan : HELPER_TEXT.anchor}
      mentionsList={mentionsList}
      {...props}
    />
  );
});

export default observer(RichTextField);

RichTextField.propTypes = {
  anchorSubscriptions: PropTypes.array.isRequired,
  isFan: PropTypes.bool.isRequired,
};
